const CONVTYPE_COUNT = 20;

export {
  CONVTYPE_COUNT,
};
